import { uql } from './uql';
import { rest } from './rest';
import { jsonata } from './jsonata';
import { uqlPaginated } from './uqlPaginated';
import { orionObject, patchOrionObject, putOrionObject } from './orion';

export const DatasourceRegistry = {
  uql,
  rest,
  jsonata,
  uqlPaginated,
  orionObject,
  patchOrionObject,
  putOrionObject,
};
